const ef_toggleList = document.querySelectorAll(".ef-section-header__toggle-item--list");
const ef_toggleGrid = document.querySelectorAll(".ef-section-header__toggle-item--grid");
const ef_gridList = document.querySelectorAll(".ef-content__block--grid-list");

document.addEventListener("click", event => {

  // If the clicked element doesn't have the right selector, bail
  if (!event.target.matches(".ef-section-header__toggle-item--list, .ef-section-header__toggle-item--list *")) return;

  // Don't follow the link
  event.preventDefault();

  for (let i = 0; i < ef_toggleList.length; i++) {
    ef_toggleList[i].classList.add("--is-active");
  }

  for (let i = 0; i < ef_toggleGrid.length; i++) {
    ef_toggleGrid[i].classList.remove("--is-active");
  }

  for (let i = 0; i < ef_gridList.length; i++) {
    ef_gridList[i].classList.add("ef-content__block--grid-list");
  }

}, false);

document.addEventListener("click", event => {

  // If the clicked element doesn't have the right selector, bail
  if (!event.target.matches(".ef-section-header__toggle-item--grid, .ef-section-header__toggle-item--grid *")) return;

  // Don't follow the link
  event.preventDefault();

  for (let i = 0; i < ef_toggleGrid.length; i++) {
    ef_toggleGrid[i].classList.add("--is-active");
  }

  for (let i = 0; i < ef_toggleList.length; i++) {
    ef_toggleList[i].classList.remove("--is-active");
  }

  for (let i = 0; i < ef_gridList.length; i++) {
    ef_gridList[i].classList.remove("ef-content__block--grid-list");
  }

}, false);
